import React, { useContext, useEffect, useState } from 'react'
import FlowAssistant from '../../../../libs/api/services/FlowAssistant'
import StickyNavigationContext from '../../../../libs/providers/StickyNavigationProvider'
import ToastDialog from '../../../../components/dialogs/toast_dialog/ToastDialog'
import ErrorDialog from '../../../../components/dialogs/ErrorDialog'
import QuestionnaireAssignmentWelcome from './wizard/QuestionnaireAssignmentWelcome'
import QuestionnaireAssignmentSelection from './wizard/QuestionnaireAssignmentSelection'
import QuestionnaireAssignmentRecipients from './wizard/QuestionnaireAssignmentRecipients'
import QuestionnaireAssignmentSchedule from './wizard/QuestionnaireAssignmentSchedule'
import QuestionnaireAssignmentDone from './wizard/QuestionnaireAssignmentDone'
import FormAssignmentWelcome from './wizard/FormAssignmentWelcome'
import FormAssignmentSelection from './wizard/FormAssignmentSelection'

export default function FormAssignmentAdmin({ onDone, onCancel, startAt, skip, defaultValues }) {
    const [step, setStep] = useState(startAt)
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [navigation, setNavigation] = useState([])
    const [errors, setErrors] = useState('')
    const [values, setValues] = useState(defaultValues ? defaultValues : {})
    const [status, setStatus] = useState({})
    const [history, setHistory] = useState({})
    const { setSticky, setPreventMessage } = useContext(StickyNavigationContext)

    const _handleSetNavigation = async (n) => {
        //alert(JSON.stringify(n))
        var _nav = []
        // var history = FlowAssistant
        //     .GetLast()

        if (onCancel) {
            _nav.push({ type: 'Cancel', action: () => onCancel(), text: 'Cancel' })
        }
        // if (history) {
        //     // _nav.push({ type: 'Action', action: () => FlowAssistant.Goto(history.section), text: 'Cancel' })
        //     // var vs = {}
        //     // for (const k of Object.keys(history.details)) {
        //     //     // const parsed = JSON.parse(history.details[k])
        //     //     try {
        //     //         vs[k] = JSON.parse(history.details[k])
        //     //     } catch (e) {
        //     //         vs[k] = history.details[k]
        //     //     }
        //     //     setValues({ ...values, ...vs })
        //     // }
        // }
        _nav = [..._nav, ...n]
        setNavigation(_nav)
    }

    useEffect(() => {
        setHistory(FlowAssistant.GetLast())
    }, [])

    useEffect(() => {
        if (step != 1 && step != 5) {
            setSticky(true)
            setPreventMessage('Configuration Incomplete', 'You have not completed the configuration process. <br/><br/>This can be completed later, however the survey will not be active until completed. <br/><br/>Are you sure you would like to cancel?')
        } else {
            setSticky(false)
        }
    }, [step])

    const _hSetValue = (v) =>
    {
        setValues({ ...values, ...v })
    }

    const _getStepSection = () => {
        if (skip && skip.includes(step)) {
            setStep(step + 1);
        }
        switch (step) {
            case 0:
                return <FormAssignmentWelcome
                    title={(t) => setTitle(t)}
                    description={(t) => setDescription(t)}
                    navigation={(t) => _handleSetNavigation(t)}
                    errors={(e) => setErrors(e)}
                    setValue={(v) => setValues({ ...values, ...v })}
                    values={values}
                />
            case 1:
                return <FormAssignmentSelection
                    title={(t) => setTitle(t)}
                    description={(t) => setDescription(t)}
                    navigation={(t) => _handleSetNavigation(t)}
                    errors={(e) => setErrors(e)}
                    setValue={(v) => setValues({ ...values, ...v })}
                    values={values}
                />
            case 2:
                return <QuestionnaireAssignmentRecipients
                    title={(t) => setTitle(t)}
                    description={(t) => setDescription(t)}
                    navigation={(t) => _handleSetNavigation(t)}
                    errors={(e) => setErrors(e)}
                    setValue={(v) => setValues({ ...values, ...v })}
                    values={values}
                />
            case 3:
                return <QuestionnaireAssignmentSchedule
                    title={(t) => setTitle(t)}
                    description={(t) => setDescription(t)}
                    navigation={(t) => _handleSetNavigation(t)}
                    errors={(e) => setErrors(e)}
                    setValue={(v) => _hSetValue(v)}
                    values={values}
                />
            case 4:
                return <QuestionnaireAssignmentDone
                    title={(t) => setTitle(t)}
                    description={(t) => setDescription(t)}
                    navigation={(t) => _handleSetNavigation(t)}
                    errors={(e) => setErrors(e)}
                    setValue={(v) => setValues({ ...values, ...v })}
                    values={values}
                />
            default:
                return <></>
        }
    }

    return (
        <>
            <ToastDialog {...status} />
            <ErrorDialog error={errors} onClose={() => setErrors('')} />
            <div
                className="Wizard top-center position-relative">
                <div className="head"><h1>{title}</h1>
                    <p dangerouslySetInnerHTML={{ __html: description }}></p>

                    <div
                        className="error-details"></div>
                </div>
                <div className="body">
                    <div
                        className=".section d-flex flex-column align-items-stretch h-100 w-100">
                        {_getStepSection()}
                    </div>
                </div>
                <div className="tail">
                    {
                        navigation.map((n) => {
                            if (n.type === 'Next')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action) {
                                            try {
                                                await n.action()
                                                    .catch(() => {
                                                        setErrors(e.message)
                                                        return
                                                    })
                                            } catch (e) {
                                                return
                                            }
                                        }
                                        if (skip) {
                                            var sk = step
                                            while (skip.includes(sk + 1))
                                                sk++
                                            sk++
                                            setStep(sk)
                                        } else {
                                            setStep(step + 1)
                                        }
                                    }} className="btn ng-buttons">{n.text}</button>
                            else if (n.type === 'Back')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action) {
                                            await n.action().catch((e) => setErrors(e.message))
                                        }

                                        if (skip) {
                                            var sk = step
                                            while (skip.includes(sk - 1))
                                                sk -= 1
                                            sk -= 1
                                            setStep(sk)
                                        } else {
                                            setStep(step - 1)
                                        }

                                    }} className="btn ng-buttons">{n.text}</button>
                            else if (n.type === 'Action')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action)
                                            await n.action()
                                                .catch((e) => setErrors(e.message))
                                    }} className="btn ng-buttons">{n.text}</button>
                            else if (n.type === 'Cancel')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action)
                                            await n.action()
                                    }} className="btn ng-buttons">{n.text}</button>
                            else if (n.type === 'Done')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action)
                                            await n.action()
                                                .catch((e) => setErrors(e.message))
                                        if (onDone)
                                            onDone(values)
                                        else
                                            setStep(1)
                                    }} className="btn ng-buttons">{n.text}</button>
                            else if (n.type === 'Step')
                                return <button
                                    key={n.text}
                                    onClick={async (e) => {
                                        if (n.action)
                                            await n.action()
                                                .catch((e) => setErrors(e.message))
                                        setStep(n.step)
                                    }} className="btn ng-buttons">{n.text}</button>
                        })
                    }
                </div>
            </div>
        </>
    )
}
